export default "__VITE_ASSET__CR8sB6Ne__"